
import React from 'react';
import "./InputTooltip.scss";

const InputTooltip = (props) => {
    return (
        <div className="InputTooltipWrapper">
            <span style={{ display: props.display }} id={props.id} className="inpTooltipText"></span>
        </div>
    )
}

export default React.memo(InputTooltip);